const headerPopups = {
    accountBtn: document.getElementById('jsAccountBtn') as HTMLElement, 
    accountWrap: document.getElementById('jsUserWrap') as HTMLElement,
    cartBtn: document.getElementById('jsCartBtn') as HTMLElement, 
    cartWrap: document.getElementById('jsCartWrap') as HTMLElement,

    init() {
        this.setHoverState();
        this.removeHoverState();
    },


    setHoverState() {
        this.accountBtn.addEventListener('mouseenter', () => {
           this.accountWrap.classList.add('activeClass');
        });

        this.cartBtn.addEventListener('mouseenter', () => {
            this.cartWrap.classList.add('activeClass');
        })


    },


    removeHoverState() {
        window.addEventListener('mouseover', (e) => {
            const target = e.target as HTMLElement; 

            if(target !== this.accountBtn && !this.accountBtn.contains(target) && target !== this.accountWrap && !this.accountWrap.contains(target) 
                &&
                target !== this.cartBtn && !this.cartBtn.contains(target) && target !== this.cartWrap && !this.cartWrap.contains(target)
            ) {
                this.accountWrap.classList.remove('activeClass');
                this.cartWrap.classList.remove('activeClass');
            }

        })
    }


}

export default headerPopups;